module.exports = __webpack_public_path__ + "static/img/store-ranking-rule-pic-1.cbdfd59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/store-ranking-rule-pic-1.png
// module id = 0FrD
// module chunks = 3